"use client";

import Image from "next/image";
import { useEffect, useState } from "react";
import { Button, Input, Form, Checkbox } from "react-vant";
import productApi from "@/service/modules/productApi";
import { toast } from "@/components/global/Toast";
import type { NotifyFormValues } from "@/types/product";
import { errorUtils } from "@/utils/error";
import Dialog from "@/components/global/Dialog";

interface Props {
  showNotify: boolean;
  productID: string;
  onClose: () => void;
}
export default function ProductNotifyDialog({
  productID,
  showNotify,
  onClose,
}: Props) {
  const [form] = Form.useForm();

  const defaultCaptcha = {
    img: "",
    key: "",
  };
  const [captcha, setCaptcha] = useState(defaultCaptcha);
  const [btnLoading, setBtnLoading] = useState(false);
  const [newsletter, setNewsletter] = useState(true);

  useEffect(() => {
    if (showNotify) {
      generate();
      form.resetFields();
    }
  }, [showNotify, form]);

  const generate = async () => {
    try {
      const res = await productApi.generate();
      const { captcha } = res.data;
      setCaptcha(captcha);
    } catch (error: unknown) {
      toast.show(errorUtils.getErrorMessage(error));
    }
  };

  // 订阅checkbox触发器
  const onChangeNewsletter = (value: boolean) => {
    setNewsletter(value);
  };

  const onFinish = async (values: NotifyFormValues) => {
    setBtnLoading(true);
    const params = {
      ...values,
      productID,
      verifyCode: values.captcha,
      key: captcha.key,
      newsletter: newsletter,
    };
    try {
      await productApi.addNotify(params);
      form.resetFields();
      setBtnLoading(false);
      onClose();
      toast.show("Success");
    } catch (error: unknown) {
      setBtnLoading(false);
      generate();
      toast.show(errorUtils.getErrorMessage(error));
    }
  };

  return (
    <Dialog
      visible={showNotify}
      title=""
      closeable={true}
      showConfirmButton={false}
      showCancelButton={false}
      onCancel={onClose}
    >
      <Form
        form={form}
        onFinish={onFinish}
        layout={"vertical"}
        footer={
          <div>
            <Button
              round
              nativeType="submit"
              type="primary"
              style={{ fontWeight: "700" }}
              loading={btnLoading}
              loadingText="Send"
              block
            >
              Send
            </Button>

            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", paddingTop: "10px" }}>
              <Checkbox
                checked={newsletter}
                onChange={onChangeNewsletter}
                shape={"square"}
                iconSize={16}
                style={{
                  margin: "2px 10px 0 0",
                  flexShrink: 0,
                  fontSize: "13px",
                  lineHeight: "16px",
                }}
              ></Checkbox>

              <div style={{ fontSize: '13px', lineHeight: '16px' }}>
                I would like to receive your Newsletter to be the first to know
                about hot offers!
              </div>
            </div>
          </div>
        }
      >
        <div
          style={{
            paddingBottom: "14px",
            fontWeight: "bold",
            color: "#D70B17",
          }}
        >
          Notify me when the item is restock！
        </div>
        <Form.Item
          rules={[{ required: true, message: `Name is required` }]}
          name="userName"
          label="Name:"
        >
          <Input placeholder="Name" maxLength={225} />
        </Form.Item>

        <Form.Item
          rules={[
            { required: true, message: `Email Address is required` },
            { type: "email", message: `Invalid Email Address` },
          ]}
          name="email"
          label="Email address:"
        >
          <Input placeholder="Email address" maxLength={225} />
        </Form.Item>

        <Form.Item label="To Generate New Code, Click Picture:">
          {
            captcha.img ? (
              <Image
                src={captcha.img}
                alt="code-image"
                width={120}
                height={35}
                style={{ cursor: "pointer" }}
                onClick={generate}
              />
            ) : null
          }
        </Form.Item>

        <Form.Item
          rules={[{ required: true, message: `Captcha is required` }]}
          name="captcha"
          label="Code:"
        >
          <Input placeholder="Code" maxLength={225} />
        </Form.Item>
      </Form>
    </Dialog>
  );
}
